module.exports = __webpack_public_path__ + "static/media/email_marketing.d400ae6b.jpg";